'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.secondsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/secondsAgo.js
// module id = 587
// module chunks = 0